export function show() {
  const overlayEl = document.querySelector('.js-loading-overlay')

  overlayEl.setAttribute('aria-status', 'active')
}

export function hide() {
  const overlayEl = document.querySelector('.js-loading-overlay')

  overlayEl.setAttribute('aria-status', 'disabled')
}

export default {
  show,
  hide,
}
